import { API_BASE_URL } from '@types';
import type { Video } from '@model/Video';
import type { Audio } from '@model/Audio';

// ============================================================================
// API FUNCTIONS
// ============================================================================

export const getVideoById = async (id: number | string): Promise<Video> => {
  const response = await fetch(
    `${API_BASE_URL}/services/v1/media/video/${id}`,
    {
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
      },
    }
  );

  if (!response.ok) {
    const errorText = await response.text();
    throw new Error(`HTTP ${response.status}: ${errorText}`);
  }

  return response.json();
};

export const getAudioById = async (id: number | string): Promise<Audio> => {
  const response = await fetch(
    `${API_BASE_URL}/services/v1/media/audio/${id}`,
    {
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
      },
    }
  );

  if (!response.ok) {
    const errorText = await response.text();
    throw new Error(`HTTP ${response.status}: ${errorText}`);
  }

  return response.json();
};

// ============================================================================
// SAFE FUNCTIONS (with error handling)
// ============================================================================

export const getVideoByIdSafe = async (
  id: number | string
): Promise<Video | null> => {
  try {
    return await getVideoById(id);
  } catch (error) {
    console.error('Error fetching video:', error);
    return null;
  }
};

export const getAudioByIdSafe = async (
  id: number | string
): Promise<Audio | null> => {
  try {
    return await getAudioById(id);
  } catch (error) {
    console.error('Error fetching audio:', error);
    return null;
  }
};
